module.exports = __webpack_public_path__ + "static/rewards-card-banner-kait-e0b94b7a8557a29336e3d2b94b446732.png";